module.exports = __webpack_public_path__ + "img/page_bg_storeVisit.a2d5950c.png";